import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Swal from 'sweetalert2'
import useProjectsApi from '../../list/hooks/useProjectsApi'

export default function useProjectAddPage() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const { createProject } = useProjectsApi()
	const [submitting, setSubmitting] = useState(false)
	const [form, setForm] = useState({
		nazwa: '',
	})

	const setField = useCallback((key, value) => {
		setForm(prev => ({ ...prev, [key]: value }))
	}, [])

	const handleCancel = useCallback(() => {
		navigate('/centrumSzkolen/projekty')
	}, [navigate])

	const handleSubmit = useCallback(async event => {
		event.preventDefault()
		if (submitting) return

		const nazwa = `${form.nazwa || ''}`.trim()
		if (!nazwa) {
			await Swal.fire(
				t('projects.add.messages.errorTitle'),
				t('projects.form.messages.nameRequired', { defaultValue: 'Nazwa projektu jest wymagana' }),
				'error'
			)
			return
		}
		setSubmitting(true)
		const result = await createProject({
			nazwa,
			status: 'new',
		})

		if (!result.success) {
			await Swal.fire(
				t('projects.add.messages.errorTitle'),
				result.error || t('projects.add.messages.createFailed'),
				'error'
			)
			setSubmitting(false)
			return
		}

		const projectId = result.data?._id || result.data?.id
		setSubmitting(false)

		if (projectId) {
			navigate(`/centrumSzkolen/projekty/details/${projectId}`)
		} else {
			navigate('/centrumSzkolen/projekty')
		}
	}, [createProject, form, navigate, submitting, t])

	return {
		form,
		setField,
		submitting,
		handleCancel,
		handleSubmit,
	}
}
